// extracted by mini-css-extract-plugin
module.exports = {"block":"Preloader_block__1vLDS","wrapper":"Preloader_wrapper__1zvTT"};